module.exports = __webpack_public_path__ + "static/media/m25_thumb_even.dd03475b.webp";